module.exports = __webpack_public_path__ + "static/media/upgrade_vip.1a5e7f94.png";